import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CatalogoProvider } from './services/catalogo';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './screens/Home';
import Pasta from './screens/Pasta';
import Busca from './screens/Busca';
import NaoEncontrado from './screens/NaoEncontrado';

// volta ao topo ao trocar de página (mas não ao digitar na busca, que só muda a query)
function RolarAoTopo() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <CatalogoProvider>
                <RolarAoTopo />
                <a className="pular-conteudo" href="#conteudo">Pular para o conteúdo</a>
                <Header />
                <main id="conteudo" tabIndex={-1}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/pasta/*" element={<Pasta />} />
                        <Route path="/busca" element={<Busca />} />
                        <Route path="*" element={<NaoEncontrado />} />
                    </Routes>
                </main>
                <Footer />
            </CatalogoProvider>
        </BrowserRouter>
    );
}

export default App;
